// extracted by mini-css-extract-plugin
module.exports = {"component":"pill_component__bGlVr","icon":"pill_icon__W4_a8","isPrimary":"pill_isPrimary__WnIQ7","isSecondary":"pill_isSecondary__VOyM6","text":"pill_text__X9Qf3"};